import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Always land at the top when navigating between routes (unless a hash is present). */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace(/^#/, '');
      const el = id ? document.getElementById(id) : null;
      if (el) {
        if (id === 'contact') {
          el.scrollIntoView({ behavior: 'smooth', block: 'end' });
        } else {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        return;
      }
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname, hash]);

  return null;
}
